import React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@/components/atoms/Typography';
import { ChangePasswordForm } from '@/components/organisms/ChangePasswordForm';
import { ProfileForm } from '@/components/organisms/ProfileForm';

export const ProfilePage = () => {
  const { t } = useTranslation();
  return (
    <div className="p-5">
      <Typography variant="h2" weight="bold">
        {t('form.editProfile')}
      </Typography>
      <div className="flex flex-col md:flex-row gap-8 mt-5">
        <ProfileForm />
        <ChangePasswordForm />
      </div>
    </div>
  );
};
